import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction, openCustomModal } from '../../../actions/modal';
import { updateUserProfileBussinessDetails } from '../../../actions/onboarding';
import { adhaarValidation, bussinessPancardValidation, removeValidateAadharResponse } from '../../../actions/users';
import Card from '../../../common/Card';
import IconToolTip from '../../../common/IconToolTip';
import InLineLabelValue from '../../../common/InLineLabelValue';
import { actualValueForDropdown, getValidationIcons, validateNumberValue, validateStringValue } from '../../../utils/common';
import { isValidAadhaar, isValidPincode, validatePAN } from '../../../utils/utils';
import Form from '../../Inventory/reusableComponents/AddOption/Form';
import Input from '../../Inventory/reusableComponents/AddOption/Input';
import GstModal from './GstModal';
import GoogleMap from '../../../common/GoogleMaps';

export const aadhar = { key: 1, value: 1, label: 'Aadhaar Card' };
export const pancard = { key: 2, value: 2, label: 'Pancard' };
export const idProofCategoryOptions = [aadhar, pancard];

function ViewAllLabel({ dataToPopulate, dataToShowPerRow, label, keyToDisplay, icon, iconColor }) {
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    const viewAllModal = (data, heading = 'view all', name) => {
        let modalWidth = '60em',
            modalHeight = '40em';
        let modalComponent = (
            <ViewAllModal icon={icon} keyToDisplay={keyToDisplay} iconColor={iconColor} data={data} closeModal={closeModal} modalWidth={modalWidth} modalHeight={modalHeight} />
        );
        let head = heading;
        dispatch(openCustomModal({ modalComponent, heading: 'Working Areas', modalWidth, modalHeight }));
    };

    return (
        <div className='flex items-center justify-between'>
            <IconToolTip title='View All'>
                <span className='text-font12 font-normal text-scogoorange cursor-pointer hover:text-scogobgsky' onClick={() => viewAllModal(dataToPopulate, `${label}`)}>
                    +{dataToPopulate?.length - dataToShowPerRow}
                </span>
            </IconToolTip>
            &nbsp;
        </div>
    );
}

export const RectangleBadge = ({ label, elementsArray, parentClass = '', icon, iconColor, chipColor = 'bg-tagbg text-scogoprimary', keyToDisplay, dataToShowPerRow = 4 }) => {
    if (!elementsArray || elementsArray?.length === 0) return <></>;
    return (
        <div className={`${parentClass} w-auto mt-2`}>
            <span className='text-gray-600 text-font12'>{label}</span>
            <div className='flex flex-wrap gap-2 mt-3'>
                {elementsArray?.slice(0, dataToShowPerRow)?.map((element, index) => {
                    let valueToShow = keyToDisplay ? element?.[keyToDisplay] : element;
                    return (
                        valueToShow && (
                            <p key={index} className={`font-md font-bold text-font12 px-p-6 py-p-3 flex items-center rounded-3px mr-2 mb-1 ${chipColor}`}>
                                {icon && <span className={`material-icons m-auto ${iconColor} text-font12 pr-2`}>{icon}</span>}
                                {valueToShow}
                            </p>
                        )
                    );
                })}
                {elementsArray?.length > dataToShowPerRow && (
                    <ViewAllLabel keyToDisplay={keyToDisplay} icon={icon} iconColor={iconColor} dataToShowPerRow={dataToShowPerRow} dataToPopulate={elementsArray} label={label} />
                )}
            </div>
        </div>
    );
};



export default function DefaultBusinessDetails({ }) {
    const { org, user, orgVerificationDocs, territories } = useSelector((state) => state.auth.newLoggedUserData);
    const dispatch = useDispatch();

    const mapMarkerData = user.address?.coords ? [{
        position: {
            lat: user.address.coords.lat,
            lng: user.address.coords.long
        },
        title: org.name || 'Business Location',
        radius: user.address.work_radius_meter || 5000
    }] : [];

    const updateBusinessDetails = () => {
        dispatch(
            openCustomModal({
                heading: `Business Details`,
                modalWidth: '40vw',
                modalHeight: 'auto',
                modalComponent: <UpdateDefaultBusinessDetailsForm />,
            })
        );
    };

    let cardActions = [{ onClick: () => updateBusinessDetails(), isToShowAction: true }];

    return (
        <Card
            className='profile_business_details shadow-lg rounded-md bg-white'
            title={'Business Details'}
            icon={'work_outline'}
            actions={cardActions}
            isLoading={false}
        >
            <div className='p-4 h-[50%]'>
                <div className='flex w-full h-full gap-4'>

                    <div className='w-full grid grid-cols-2 gap-4 ' >
                        <div className='bg-white p-4 rounded-md shadow-sm transition-all duration-300 hover:shadow-md border border-gray-100'>
                            <div className='flex items-center gap-2'>
                                <span className='material-icons text-scogoprimary text-lg'>business</span>
                                <InLineLabelValue
                                    label={'Company Name'}
                                    value={org.name}
                                    labelClassName="text-gray-600 font-medium text-font10"
                                    valueClassName="font-normal text-gray-800 text-font10"
                                />
                            </div>
                        </div>

                        {user.address?.plain_text && (
                            <div className='bg-white p-4 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md border border-gray-100'>
                                <div className='flex items-center gap-2'>
                                    <span className='material-icons text-scogoprimary text-lg'>location_on</span>
                                    <InLineLabelValue
                                        truncate={false}
                                        label={'Address'}
                                        value={user.address?.plain_text}
                                        labelClassName="text-gray-600 font-medium text-font10"
                                        valueClassName="font-normal text-gray-800 text-font10"
                                    />
                                </div>
                            </div>
                        )}

                        <div className='bg-white p-4 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md border border-gray-100'>
                            <div className='flex items-center gap-2 mb-2'>
                                <span className='material-icons text-scogoprimary text-lg'>verified_user</span>
                                <span className='text-gray-600 font-medium text-font10'>Verification Documents</span>
                            </div>
                            <RenderVerificationDocs orgVerificationDocs={orgVerificationDocs} />
                        </div>

                        {territories.length > 0 && (
                            <div className='bg-white p-4 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md border border-gray-100'>
                                <div className='flex items-center gap-2 mb-2'>
                                    <span className='material-icons text-scogoprimary text-lg'>map</span>
                                    <span className='text-gray-600 font-medium text-font12'>Working Areas</span>
                                </div>
                                <RectangleBadge
                                    elementsArray={territories}
                                    chipColor='bg-blue-50 text-blue-700'
                                    icon="location_on"
                                    iconColor="text-blue-500"
                                    keyToDisplay='name'
                                />
                            </div>
                        )}
                    </div>

                    {/* <div className='w-7/12 h-full rounded-lg overflow-hidden shadow-md border border-gray-200'>
                        <GoogleMap
                            markerData={mapMarkerData}
                            defaultZoom={14}
                            mapContainerStyle={{ height: '100%', borderRadius: '0.5rem' }}
                            showCircle={true}
                        />
                    </div> */}
                </div>
            </div>
        </Card>
    );
}

const UpdateDefaultBusinessDetailsForm = () => {
    const dispatch = useDispatch();
    const { isBussinessPanVerified, cities, states, spProfileDetails, isAadharVerified, is_aadhar_is_already_verified, aadharKycResponse } = useSelector((state) => state.user);
    const { isBussinessPanVerificationLoading } = useSelector((state) => state.loading);
    const { loggedUser } = useSelector((state) => state.auth);
    const aadharOtpRef = useRef();
    const servicePartnerId = loggedUser?.service_partner_id;
    const formName = 'updateBusinessDetailsForm';

    useEffect(() => {
        return () => {
            dispatch(removeValidateAadharResponse());
        }
    }, [dispatch]);

    const initialValues = {
        sp_name: spProfileDetails?.company_detail?.sp_name ? spProfileDetails?.company_detail?.sp_name : `${loggedUser?.first_name} ${loggedUser?.last_name}`,
        sp_address_line_1: spProfileDetails?.company_detail?.sp_address_line_1,
        sp_primary_pincode: spProfileDetails?.company_detail?.sp_primary_pincode,
        sp_pan_card_number: spProfileDetails?.company_detail?.sp_pan_card_number,
        sp_adhaar_number: spProfileDetails?.company_detail?.sp_adhaar_number,
        sp_have_gst: false,
        cities,
        id_proof_type: pancard,
    };
    const [form, setForm] = useState(initialValues);
    const [showIcon, setShowIcon] = useState(false);

    const isToShowPanOrAadharInEditDetails =
        !validatePAN(spProfileDetails?.company_detail?.sp_pan_card_number) && !isValidAadhaar(spProfileDetails?.company_detail?.sp_adhaar_number);

    useEffect(() => {
        if (spProfileDetails?.company_detail?.office?.length > 0 && cities?.length > 0) {
            let location_data = spProfileDetails?.company_detail?.office;
            let pre_selected_cities = location_data?.map((location) => {
                return location.fk_city_id;
            });
            let cityObj = cities.filter(({ value }) => pre_selected_cities.includes(value));
            let detail = { cities: cityObj };
            setForm((prevState) => ({ ...prevState, ...detail }));
        }
    }, [cities, states, spProfileDetails?.company_detail?.office]);

    const submitBusinessDetails = (formValues) => {
        dispatch(updateUserProfileBussinessDetails({ formValues, servicePartnerId, formName }));
    };

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    const onPanChange = (event) => {
        const { value } = event.target;
        setShowIcon(false);
        if (validatePAN(value)) {
            setShowIcon(true);
            dispatch(bussinessPancardValidation({ pan_number: value }));
        }
    };

    useEffect(() => {
        if (isAadharVerified && isToShowPanOrAadharInEditDetails) {
            aadharOtpRef?.current?.click();
            setShowIcon(true);
        }
    }, [isAadharVerified, isToShowPanOrAadharInEditDetails]);

    const onAadharChange = (event) => {
        const { value } = event.target;
        if (isValidAadhaar(value) && !isAadharVerified) {
            dispatch(adhaarValidation({ aadhaar_number: value }));
        }
    };

    useEffect(() => {
        if (aadharKycResponse && !is_aadhar_is_already_verified) {
            aadharOtpRef?.current?.click();
        }
    }, [aadharKycResponse, is_aadhar_is_already_verified])

    return (
        <div className='p-6 bg-white rounded-lg'>
            <Form
                className='w-full'
                submit={(e) => {
                    submitBusinessDetails(e);
                }}
                buttonPostion={'justify-end'}
                formName={formName}
                initialValues={initialValues}
                form={form}
                submitButtonName={'Update'}
                setForm={setForm}
                onCancel={() => closeModal(false)}
            >
                <div className='grid grid-cols-3 gap-4 items-end'>
                    <Input
                        label='Company Name'
                        name='sp_name'
                        required
                        type={'text'}
                        className='focus:ring-2 focus:ring-blue-500'
                    />
                    <Input
                        label='Address'
                        className='col-span-2 focus:ring-2 focus:ring-blue-500'
                        name='sp_address_line_1'
                        required
                        type={'text'}
                    />
                    {isToShowPanOrAadharInEditDetails && (
                        <>
                            <Input
                                label='Id Proof Type'
                                placeholder='Select Id Proof'
                                name='id_proof_type'
                                type={'dropdown'}
                                defaultValue={pancard}
                                required
                                options={idProofCategoryOptions}
                                className={'w-full text-left focus:ring-2 focus:ring-blue-500'}
                            />
                            <div className='col-span-2'>
                                {actualValueForDropdown(form.id_proof_type) === pancard.value && (
                                    <>
                                        <Input
                                            name='sp_pan_card_number'
                                            required
                                            label='Pan Card Number'
                                            type={'text'}
                                            customMethod={onPanChange}
                                            className={'w-full text-left focus:ring-2 focus:ring-blue-500'}
                                            maxLength={10}
                                            customValidation={validatePAN}
                                            errorMessage={'Invalid Pan Number'}
                                            iconLoader={isBussinessPanVerificationLoading}
                                            isEditable={!validatePAN(form?.sp_pan_card_number)}
                                            inputIcon={showIcon && getValidationIcons(isBussinessPanVerified)}
                                        />
                                    </>
                                )}
                                {actualValueForDropdown(form.id_proof_type) === aadhar.value && (
                                    <>
                                        <Input
                                            label='Aadhaar Number'
                                            customValidation={isValidAadhaar}
                                            errorMessage={'Invalid Aadhaar'}
                                            customMethod={onAadharChange}
                                            name='sp_adhaar_number'
                                            maxLength={12}
                                            isEditable={!isAadharVerified}
                                            required
                                            type={'text'}
                                            className={'w-full text-left focus:ring-2 focus:ring-blue-500'}
                                            inputIcon={showIcon && getValidationIcons(isAadharVerified)}
                                        />
                                    </>
                                )}
                            </div>
                        </>
                    )}

                    <Input
                        label='Pincode'
                        customValidation={isValidPincode}
                        errorMessage={'Invalid Pincode'}
                        name='sp_primary_pincode'
                        required
                        type={'text'}
                        className='focus:ring-2 focus:ring-blue-500'
                    />

                    <Input
                        label='Select Cities to work with Scogo'
                        placeholder='Select Cities'
                        name='cities'
                        type={'dropdown'}
                        isMulti={true}
                        options={cities && cities}
                        className={'col-span-2 max-h-[20rem] overflow-y-auto border-b-2 focus:ring-2 focus:ring-blue-500'}
                    />
                </div>
            </Form>
            <div className='flex items-center gap-2 relative'>
                {/* <MiniPopup
                    handleClick={() => { }}
                    popup={<VerifyAadharForm aadhar_number={form?.sp_adhaar_number} closeModalAfterSuccess={false} />}
                    transition={false}
                    className='fixed px-3 py-2 mt-2 z-10 rounded-md shadow-lg bg-white overflow-scroll left-0 top-0 border-2'
                    menuStyle={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
                >
                    <div ref={aadharOtpRef} />
                </MiniPopup> */}
            </div>
        </div>
    );
};

const ViewAllModal = (props) => {
    const { data, icon, keyToDisplay, iconColor } = props;
    const [allData, setAllData] = useState(data);
    const boxStyle = {
        border: 0,
        p: 1,
        height: '40em',
        width: '60em',
        bgcolor: 'white',
    };

    const handleSearch = (e) => {
        let searchKey = e.target.value.trim().toLowerCase();
        if (searchKey === '') {
            setAllData(data);
            return;
        }
        const valueListWithSearchTerm = allData.filter((value) => {
            if (keyToDisplay) {
                return value?.[keyToDisplay]?.toLowerCase().includes(searchKey);
            } else {
                return value.toLowerCase().includes(searchKey);
            }
        });
        setAllData(valueListWithSearchTerm);
    };

    return (
        <Box sx={boxStyle} className='shadow-2xl overflow-auto rounded-lg'>
            <input
                onChange={handleSearch}
                className='w-full py-2 my-2 px-4 border-2 rounded-md text-font11 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                placeholder={'Search'}
            />
            <div className='flex flex-wrap gap-2 items-center px-4 py-4'>
                {Array.isArray(allData) &&
                    allData.map((element, index) => {
                        return (
                            <p key={index} className={`bg-tagbg font-medium text-scogoprimary 2xl:text-font11 text-font10 px-3 py-2 flex items-center rounded-md mr-2 mb-2 transition-all hover:bg-blue-100`}>
                                {icon && <span className={`material-icons m-auto ${iconColor} text-font13 pr-2`}>{icon}</span>}
                                {keyToDisplay ? element?.[keyToDisplay] : element}
                            </p>
                        );
                    })}
            </div>
        </Box>
    );
};

const RenderVerificationDocs = ({ orgVerificationDocs }) => {
    return (
        <div className='flex flex-col gap-2'>
            {orgVerificationDocs?.length > 0 && orgVerificationDocs.map((doc, index) => {
                return (
                    <div key={index} className='flex items-center gap-2 bg-gray-50 p-2 rounded-md'>
                        <InLineLabelValue
                            valueClassName={'uppercase font-medium text-gray-800 text-font10'}
                            labelClassName={'text-gray-600 font-medium text-font10'}
                            label={doc.label}
                            value={doc.value}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export const PanAdharLinkeStatus = ({ is_pancard_linked_with_aadhaar }) => {
    let text = '';
    let color = '';

    if (is_pancard_linked_with_aadhaar === 0) return <></>;
    else if (is_pancard_linked_with_aadhaar === 1) {
        text = 'Linked With Aadhaar';
        color = 'text-green-600';
    } else if (is_pancard_linked_with_aadhaar === -1) {
        text = 'Not Linked With Aadhaar';
        color = 'text-red-600';
    } else if (is_pancard_linked_with_aadhaar === -2) {
        text = 'Invalid Pancard';
        color = "text-red-600";
    }

    return (
        <span className={`${color} pt-1 font-medium flex items-center`}>
            <span className="material-icons text-font12 mr-1">
                {is_pancard_linked_with_aadhaar === 1 ? 'check_circle' : 'error'}
            </span>
            {text}
        </span>
    );
};